import Container from "../components/common/Container";
import PageHeader from "../components/common/PageHeader";
import CorrectionRequestQueue from "../components/Reports/CorrectionRequestQueue";

/**
 * Çalışan bildirimleri kuyruğu (plan 2.50).
 *
 * Raporların altında duruyor çünkü verdiği karar doğrudan puantajı değiştiriyor
 * ve kabul edilen bildirim Giriş/Çıkış raporundaki düzeltmeye dönüşüyor.
 */
const CorrectionRequests = () => {
  return (
    <Container>
      <PageHeader
        pageTitle="Çalışan Bildirimleri"
        subText="Çıkışını okutmayı unutan çalışanların bildirdiği saatler. Kabul ettiğiniz bildirim gün satırındaki düzeltmeye dönüşür."
      />
      <CorrectionRequestQueue />
    </Container>
  );
};

export default CorrectionRequests;
